import YogaLabel from './YogaLabel'

export default YogaLabel
// eslint-disable-next-line import/export
export * from './YogaLabel'
